export default "__VITE_ASSET__877ffd21__"